import React from "react";
import BubbleView from "./BubbleView";
import {OverlayTrigger, Popover, ProgressBar, Tooltip} from "react-bootstrap";
import CategoryView from "./CategoryView";
import axios from "axios";
import {API} from "../../service/api";
import legend from "../../Icons/website legend.png"
import ExplanationNote from "./ExplanationNote";
import {Inspector, Runtime} from "@observablehq/runtime";
import circleLegend1 from "../@d3/CircleLegendCourseComments";
import {commentsRate} from "./DataHelperFn";
import pieChart1 from "../@d3/PieChartCourseComments";

const VisualizationView = (props) =>{
    const qid = props.qid;
    const cid = sessionStorage.getItem("cid")
    const [bubbleData, SetBubbleData] = React.useState(null);

    // let bubbleData = JSON.parse(sessionStorage.getItem(`${qid}Bubble`))
    React.useEffect(() =>{
        if(sessionStorage.getItem(`${qid}Bubble`)!=null){
            SetBubbleData(JSON.parse(sessionStorage.getItem("courseBubble")))
        }else{
            axios({
              method: 'get',
              url: `${API}/Bubbles/${qid}-${cid}`,
            }).then(function (response) {
                sessionStorage.setItem(`${qid}Bubble`, JSON.stringify(response.data.data))
                SetBubbleData(JSON.stringify(response.data.data))
            }).catch((error) =>{
                console.log(error)
            })
        }

    }, [])

    const [categoryInfo, SetCategoryInfo] = React.useState(null);
    const [category, SetCategory] = React.useState(null);

    const handleClick = (e) =>{
        SetCategoryInfo(e.target.dataset.info)
        SetCategory(JSON.parse(e.target.dataset.info).category)
    }

    function capitalize(s)
    {
        return s[0].toUpperCase() + s.slice(1);
    }

        // circle legend for course
    const circleRef1 = React.useRef();
    const [loadCircleCC, setLoadCircleCC] = React.useState(true);
        React.useEffect(()=>{
              axios.get(`${API}/${capitalize(qid)}Stats/${cid}`).then((response)=>{
              let stats = response.data.data
                const circleLegendComments = {
                  tickValues:[100, parseInt(stats[2]/stats[0]*100)],
                  data: [stats[0], stats[2]]
                }
                sessionStorage.setItem("CircleCC", JSON.stringify(circleLegendComments));
              }).catch((error)=>{
                  console.log(error)
              }).finally(()=>{
                  setLoadCircleCC(false)
              })
    }, [qid])
    React.useEffect(()=>{
        if(!loadCircleCC){
            const runtime = new Runtime();
            runtime.module(circleLegend1, Inspector.into(circleRef1.current));
            return () => runtime.dispose();
        }
    }, [loadCircleCC])
        // pie chart for course
    const pieRef1 = React.useRef();
    const [loadPieCC, setLoadPieCC] = React.useState(true);

    React.useEffect(()=>{
            axios({
                method: 'get',
                url: `${API}/Tables/${qid}-${cid}`,
                headers: {
                  'Access-Control-Allow-Origin': '*',
                    withCredentials: true
                },
            }).then((response)=>{
                console.log(commentsRate((response.data.data)))
                sessionStorage.setItem("PieCC", JSON.stringify(commentsRate(response.data.data)));
              }).catch((error) =>{
                console.log(error)
              }).finally(()=>{
                  setLoadPieCC(false);
            })
    },[qid])
    React.useEffect(()=>{
        if(!loadPieCC){
            const runtime = new Runtime();
            runtime.module(pieChart1, Inspector.into(pieRef1.current));
            return () => runtime.dispose();
        }
    }, [loadPieCC])

    const explanation1 = ["How are sentiments calculated?",
        "We used a machine learning model to predict the sentence-level comment sentiments"]

    const [tableData, setTableData] = React.useState(null);
        React.useEffect(()=>{
        if(sessionStorage.getItem(`${qid}Scatter`)==null){
            axios({
              method: 'get',
              url: `${API}/Scatters/${qid}-${cid}`,
            }).then(function (response) {
                setTableData(response.data.data)
                  sessionStorage.setItem(`${qid}Scatter`, JSON.stringify(response.data.data))
            })
        }else{
            setTableData(JSON.parse(sessionStorage.getItem(`${qid}Scatter`)))
        }
    },[])

    return(
        <>
            <div className={"row-block"}>
                    <div className={"sub-block"} style={{width: "45vw", height: "40vh"}}>
                        <h5>Response Rate</h5>
                        <div style={{display: "flex", textAlign: "left", width: "30vw"}}>
                            {loadCircleCC?<div>loading...</div>:<div ref={circleRef1}></div>}
                        </div>
                        {/*<ul style={{paddingTop: "1em"}}>*/}
                        {/*    <li>Out of 283 total reviews, 48 of the reviews have non-empty written comments</li>*/}
                        {/*</ul>*/}
                    </div>
                    <div className={"sub-block"} style={{width: "30vw", height: "40vh"}}>
                        <h5>Sentiment</h5>
                        <ExplanationNote data={explanation1}/>
                        {loadPieCC?<div>loading...</div>:<div ref={pieRef1}></div>}

                    </div>
                </div>

            <BubbleView qid={qid}/>

            <div>Read comments that mentions</div>
            {console.log(bubbleData==null)}
            {(bubbleData!=null)?<div className={"category-tab-container"}>
                {Array.from(bubbleData).filter(item => item.summary != "").sort((a, b) => (b.sentimentScore - a.sentimentScore)).map((item, i) => (
                    // <div key={`tab${i}`} data-info={JSON.stringify(item)} className={"category-tab"} onMouseEnter={handleHover}>{item.category}</div>
                    <div onClick={handleClick} style={{zIndex: "1000"}}>
                        <OverlayTrigger
                          key={item}
                          placement={'bottom'}
                          overlay={
                            // <Tooltip id={`tooltip-${item}`} style={{backgroundColor: "white", color: "black"}}>
                            //     {item.name}
                            // </Tooltip>

                              <Popover id="popover-basic">
                                <Popover.Header as="h3">{item.name}</Popover.Header>
                                <Popover.Body>
                                    <p>Mentioned in {tableData.filter(e => e.category==item.category).length} comments</p>
                                    <ProgressBar>
                                      <ProgressBar striped style={{backgroundColor: "#40B0A6"}} now={Math.round(item.sentimentScore*100)} key={1} label={`${Math.round(item.sentimentScore*100)}%`}/>
                                      <ProgressBar striped style={{backgroundColor: "#E1BE6A"}} now={100-Math.round(item.sentimentScore*100)} key={2} label={`${100-Math.round(item.sentimentScore*100)}%`}/>
                                    </ProgressBar>
                                </Popover.Body>
                              </Popover>
                          }
                        >
                          <div key={`tab${i}`} data-info={JSON.stringify(item)} className={"category-tab"}>{item.category}</div>
                        </OverlayTrigger>
                    </div>

                ))}
            </div>:<div>loading...</div>}
            {(categoryInfo!=null)?<CategoryView categoryInfo={categoryInfo} qid={qid}/>:<div></div>}
        </>
    )
}

export default VisualizationView;